module.exports = __webpack_public_path__ + "media/alaska/mount_stream-75241944.jpg";